import { Box, IconButton, Stack, styled } from '@mui/material';

export const SubgoalRoot = styled(Box)({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  paddingBottom: 24,
  borderBottom: '1px solid #D8E5E8',
  width: '100%',
  scrollMarginTop: 130,
});

export const FieldsGrid = styled(Box)({
  display: 'flex',
  gap: 16,
  alignItems: 'flex-start',
  width: '100%',
  '& > .name': { flex: 1, minWidth: 0 },
  '& > .weight': { flex: '0 0 160px' },
  '& > .scale': { flex: '0 0 206px' },
  // Push the remove button down by label-height + gap so it sits in
  // line with the inputs while siblings stay top-aligned. With
  // top-alignment, validation helperText grows the field downward
  // without bumping neighbouring fields.
  '& > .remove': {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: 26,
  },
});

export const FieldGroup = styled(Stack)({
  gap: 4,
  width: '100%',
});

export const FieldLabel = styled('label')({
  display: 'inline-flex',
  alignItems: 'flex-start',
  gap: 2,
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '22px',
  color: '#768691',
  '& .required': {
    color: '#FF0D0D',
    fontSize: 15,
    lineHeight: '18px',
  },
});

export const RemoveColumn = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const DragHandleColumn = styled(Box)({
  position: 'absolute',
  left: -22,
  top: 26,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  opacity: 0,
  transition: 'opacity 120ms',
});
DragHandleColumn.defaultProps = { className: 'subgoal-drag-handle' };

export const DragHandleButton = styled(IconButton)({
  width: 20,
  height: 40,
  padding: 0,
  color: '#6E7071',
  cursor: 'grab',
  touchAction: 'none',
  '&:active': {
    cursor: 'grabbing',
  },
});
